import request from "@/utils/request";
import { getInviteCode } from "@/utils/inviteCode";

export function getPhoneCode(phone) {
  return request({
    url: "/auth/login/sms",
    method: "post",
    params: {
      phone
    }
  });
}

export async function authLogin(phone, code) {
  const inviteCode = await getInviteCode();
  return request({
    url: "/auth/login",
    method: "post",
    data: {
      phone,
      code,
      topCustomerId: inviteCode
    }
  });
}
